<app-dialog-header [title]="'ENGAGE.AUDIENCE.DIALOGS.NEW_AUTOMATIC_AUDIENCE.TITLE'" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div class="p-24" fxLayout="column" fxLayoutAlign="start">
    <form class="new-automatic-audience-form" [formGroup]="formGroup">
        <mat-form-field>
            <mat-label>{{ 'ENGAGE.AUDIENCE.DIALOGS.NEW_AUTOMATIC_AUDIENCE.LABELS.NAME' | translate }}</mat-label>
            <input matInput type="text" formControlName="name" (keyup)="handleKeyUp($event)" />
        </mat-form-field>
    </form>
</div>
<div class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>
    <app-flat-button [label]="'GENERAL.BUTTON.SAVE'" (onClick)="onAddNewAutomaticAudience()" [disabled]="!formGroup.valid"></app-flat-button>
</div>
